/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IMfrmHelpsWithSleepDisruptorsViewProps } from './mfrm-helps-with-sleep-disruptors';
import { Caret } from './svg/Caret';
export interface TitleListAboutProps {
    title: string | undefined;
    list: any[];
    linkHref: string | undefined;
    linkAreaLabel: string | undefined;
    linkText: string | undefined;
}

export const TitleListAbout: React.FC<TitleListAboutProps> = ({ title, list, linkHref, linkAreaLabel, linkText }) => {
    return (
        <div className='mfrm-helps-for-sleep-disruptors-container'>
            <div className='helps-with__heading'>{title}</div>
            {list.map((item, i) => (
                <div key={i} className='helps-with__display-text'>
                    {item}
                </div>
            ))}
            <div className='helps-with__display-about'>
                <a className='helps-with__display-about-link' href={linkHref} aria-label={linkAreaLabel} role='link'>
                    <span className='helps-with__link-text'>{linkText || 'Link'}</span>
                    <span className='helps-with__link-caret'>
                        <Caret />
                    </span>
                </a>
            </div>
        </div>
    );
};

export default (props: IMfrmHelpsWithSleepDisruptorsViewProps) => {
    const {
        data: {
            productSpecificationData: { result: productSpecificationData },
            sleepDisuptorIconsData: { result: sleepDisuptorIconsData }
        },
        config: { titleHeadingTag, aboutLink, productSpecificationDataAttributeName }
    } = props;

    const features = productSpecificationData
        ?.find(obj => obj?.Name?.toLowerCase().trim() === productSpecificationDataAttributeName?.toLowerCase().trim())
        ?.TextValue?.split(',');

    const productType = productSpecificationData?.find(obj => obj.Name?.toLocaleLowerCase().trim() === 'product type')?.TextValue;

    // TODO: This is just mocking the data, move this to a real mock
    // const features = 'Adjustable Base,Pressure Relief,Cooling Technology,Hypo Allergenic'.split(',');

    let sleepDisruptors: string[] = [];
    if (features?.includes('Adjustable Base Friendly') || productType === 'Adjustable Bases') {
        sleepDisruptors.push('Sleep Apnea', 'Acid Reflux', 'Snoring');
    }
    if (features?.includes('Cooling Technology') || features?.includes('Breathable')) {
        sleepDisruptors.push('Temperature');
    }
    if (features?.includes('Hypo Allergenic')) {
        sleepDisruptors.push('Allergies');
    }
    if (features?.includes('Pressure Relief') || features?.includes('Support')) {
        sleepDisruptors.push('Pain', 'Toss And Turn');
    }
    if (features?.includes('Motion Separation')) {
        sleepDisruptors.push('Bed Partner');
    }

    sleepDisruptors = sleepDisruptors.sort((a, z) => a.localeCompare(z));

    if (sleepDisruptors?.length) {
        return (
            <TitleListAbout
                title={titleHeadingTag}
                list={sleepDisruptors.map(sleepDisruptor => {
                    return (
                        <>
                            {sleepDisuptorIconsData && sleepDisuptorIconsData[sleepDisruptor] ? (
                                <div>
                                    <img
                                        alt={`${sleepDisruptor} icon`}
                                        className={'help-with_image'}
                                        src={sleepDisuptorIconsData[sleepDisruptor] || ''}
                                    />
                                </div>
                            ) : (
                                <div></div>
                            )}
                            {sleepDisruptor}
                        </>
                    );
                })}
                linkHref={aboutLink?.linkUrl.destinationUrl}
                linkAreaLabel={aboutLink?.ariaLabel}
                linkText={aboutLink?.linkText}
            />
        );

    } else {
        return <></>;
    }
};
